export const initialState = {
    marketGroup: {}
};
